import { prop } from '@neo/ramda-extra'
import { createSelector } from '@reduxjs/toolkit'

const selectUiState = prop('ui')

const selectIsNavDrawerOpen = createSelector(selectUiState, prop('isNavDrawerOpen'))

export { selectIsNavDrawerOpen }
